import useUser from 'shared/hooks/use-user'

export const useDownloadInvoiceLink = () => {
  const { isAffiliate, isCustomer } = useUser()
  let basePart: string = ''
  if (isAffiliate) {
    basePart = `/api/dashboard/affiliate/payment/purchase-invoices/download/`
  }
  if (isCustomer) {
    basePart = `/api/dashboard/customer/payment/purchase-invoices/download/`
  }
  return (invoiceId: number) => (basePart ? `${window.location.origin}${basePart}${invoiceId}` : '')
}
